import { useState } from 'react';
import Head from "next/head";
import Image from "next/image"
import { useRouter } from 'next/router';
//import tnpscwebbanner from "../../assets/images/Tnpsc/TNPSC-Group-II-and-IIa-Mock-test-Web-Banner.jpg";
//import tnpscmobbanner from "../../assets/images/Tnpsc/TNPSC-Group-II-and-IIa-Mock-test-Mobile-Banner.jpg";
import { NewStudentForm } from '../../components/Tnpsc-Paymentgateway/PaymentgatewayNewstd';
import callbtn from "../../assets/images/contact/contact_.png";
import { ExistingStudentForm } from '../../components/Tnpsc-Paymentgateway/PaymentgatewayOldstd';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from "next/link";
import styles from "../sch-test/delhi-prefit.module.css";

export default function MobileCheck() {
  const [mobile, setMobile] = useState('');
  const [studentType, setStudentType] = useState('check');
  const router = useRouter(); 
  const [isloading, setLoading] = useState(false);
  const [existingData, setExistingData] = useState(null);



  // const checkStudent = async () => {
  //   if (!mobile || mobile.length !== 10) {
  //     alert('Please enter a valid 10-digit mobile number!');
  //     return;
  //   }

  // const token = "NDp4UVRybXJ6Zktvd3c=";
  //  //setLoading(true);

  //   try {
  //   const res = await fetch('https://www.shankariasacademy.com/blog/wp-json/cf7/v2/tnpscgrIIusercheck', {
  //       method: 'POST',
  //       headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({ RegMobile: mobile }),
  //   });

  //   const data = await res.json();
  //   console.log('Mobile:', mobile);
  //   console.log('API Response:', data);
    
  //   if (data.status === 'success') {
  //     const paresedData = data.value
  //     setExistingData(paresedData);
  //       console.log('Mobile found. Opening existing form.');
  //       setStudentType('existing');
  //   } else {
  //       console.log('Mobile not found. Opening new form.');
  //       setStudentType('new');
  //   }

  //   } catch (error) {
  //   console.error('API error:', error);
  //   setStudentType('new');
  //   } finally {
  //   setLoading(false);
  //   }
  //   };

   const prelimlist =[
   
    {list:" Registration Closing Date: 15th September 2025"},
    {list:" Date of downloading of Mock Test Hall-Ticket: 18th September 2025 at 5:00 PM"},
    {list:" Mode of Mock Test: Only Offline mode"},
    {list:" Mock Test Results: 22nd September 2025 at 6:00 PM"}, 
           
        
    ]

  
  return (
    <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title> TNPSC Group II/IIA Prelims State Level Mock Test 2025</title>
            <meta name="title" content="TNPSC Group II/IIA Prelims State Level Mock Test 2025" />
            <meta name="description" content="Register for TNPSC Group II/IIA Prelims State Level Free Mock Test 2025. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
		      	<meta name="keywords" content="TNPSC Group II/IIA Prelims State Level Mock Test 2025, TNPSC Group II/IIA Prelims State Level Mock Test, TNPSC Group II & IIA Prelims Mock Test 2025, TNPSC Group II & IIA Prelims Mock Test, TNPSC Group II Prelims Mock Test, TNPSC Group IIA Prelims Mock Test, Group II & IIA Prelims Mock Test, All India Prelims Mock Test 2025, All India Prelims Mock Test" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-mock-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content=" TNPSC Group II/IIA Prelims State Level Mock Test 2025" />
            <meta property="og:description" content="Register for TNPSC Group II/IIA Prelims State Level Free Mock Test 2025. Get full syllabus coverage, state ranking, expert feedback & detailed analysis." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-II-IIA-prelims-mock-test/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="sch-test" />
      
      <div className="container p-3">
          <h1 className={`${styles.contactheader} pt-2 `}>
              TNPSC Group II/IIA Prelims State Level Mock Test 2025
          </h1>
        {/* <div className='row pt-2 d-none d-md-block'>
            <div className='col'>
                <Image src={tnpscwebbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"/>
            </div>
        </div>
        <div className='row pt-2 d-block d-md-none'>
            <div className='col'>
              <Image src={tnpscmobbanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test"  />
            </div>
        </div> */}
      </div>

       {/* <div className='text-center pt-4 '>
         <h2 className={`${styles.Feature}  `} style={{color: '#DB1B0D'}} > Registration Closed </h2>
       </div> */}
       <section style={{ background: "#e2f6ff 0% 0% no-repeat padding-box", opacity: "1" }}>
<div className="container" >
        <div className="row p-2" >
          
              <div className="col-12 text-center pt-2 pb-2">
                <h3 className={`${styles.sectiontitle} pt-3`}>
                  TNPSC Group II/IIA Prelims State Level Mock Test 2025 - Result<br />
                </h3>
                <div className="col-12  pt-2 pb-2">
                    <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GS-GT-Result.pdf" target="_blank" rel="noopener noreferrer" >
                      <button className={styles.tnpscmobtn} type="button">
                        GS & GT - Result
                      </button>
                    </a>
                </div>

                 <div className="col-12  pt-2 pb-2">
                    <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GS-GE-Result.pdf" target="_blank" rel="noopener noreferrer">
                      <button className={styles.tnpscmobtn} type="button">
                        GS & GE - Result
                      </button>
                    </a>
                </div>
                <div className="col-12  pt-2 pb-2">
                <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GT-GE-Combined-Result.pdf" target="_blank" rel="noopener noreferrer">
                  <button className={styles.resultbtn} type="button">
                   GT & GE Combined - Result
                  </button>
                </a>
                </div>
                <div className="col-12  pt-2 pb-2">
                <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GS-GT-Result-ADYAR.pdf" target="_blank" rel="noopener noreferrer">
                  <button className={styles.resultbtn} type="button">
                   GS & GT Adyar - Result
                  </button>
                </a>
                </div>
              </div>
              
          </div>
          <div className="row mb-4 p-2" >
          
              <div className="col-12 text-center pt-2 pb-2">
                <h3 className={`${styles.sectiontitle} pt-3`}>
                  TNPSC Group II/IIA Prelims State Level Mock Test 2025 - Key<br />
                </h3>
                <div className="col-12  pt-2 pb-2">
                    <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GS-GE-State-Level-Mock-Key.pdf" target="_blank" rel="noopener noreferrer" >
                      <button className={styles.tnpscmobtn} type="button">
                        
                         GS & GE - Key
                      </button>
                    </a>
                </div>

                 <div className="col-12  pt-2 pb-2">
                    <a href="https://www.shankariasacademy.com/pdf/tnpsc-mocktest-result-2025/GS-GT-State-Level-Mock-Key.pdf" target="_blank" rel="noopener noreferrer">
                      <button className={styles.tnpscmobtn} type="button">
                       GS & GT - Key
                      </button>
                    </a>
                </div>
               
              </div>
          </div>
        </div>
        </section>

      {/* <div className="container" >
        <div className="col-12 text-center pt-2 pb-2">
          <h3 className={`${styles.sectiontitle} pt-3`}>
            Download - Mock Test Hallticket <br />
          </h3>
          <a href="/hallticket" target="_blank" rel="noopener noreferrer">
            <button className={styles.tnpscmobtn} type="button">
              Click Here to Download
            </button>
          </a>
        </div>
</div> */}


      {/* <NewStudentForm /> */}

      {/* <div className="container" >
        <div className="row mb-4" style={{ background: "#e2f6ff 0% 0% no-repeat padding-box", opacity: "1" }}>
          {studentType === 'check' && (
            <>
              
              <div className="col-md-6">
                <h2 className={`${styles.contactheader1} pt-2 mb-4 text-center`}>
                <span  style={{color: '#DB1B0D'}}>Registration for </span><br />SIA TestSeries Students
              </h2>
              <div className="col-md-4 offset-md-4 mb-3">
                <div className="mb-3">
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Enter your mobile number *"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    pattern="[0-9]{10}"
                    required
                  />
                </div>
              </div>

              <div className="">
                <button className={`${styles.freebutton}`} onClick={checkStudent}>
                  Submit
                </button>
              </div>
            </div>

            <div className="col-md-6">
            
              <h2 className={`${styles.contactheader1} pt-2 mb-4 text-center`}>
                <span  style={{color: '#DB1B0D'}}>Registration for </span><br />Non TestSeries Students
              </h2>

              <div className="">
               <button className={`${styles.paybutton}`} onClick={() => setStudentType('new')}>
                  Next
                </button>
              </div>
            </div>
              
            </>
          )}
         {studentType === 'existing' && <ExistingStudentForm  data={existingData} />}
         {studentType === 'new' && <NewStudentForm />}
        </div>
      </div> */}

    
            {/* <section className="pt-md-3 pt-lg-4 " style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
                <div className="container"> 
                    <div className="row">
                    <h2 className={`${styles.Feature}  mb-0`} > Mock Test Details </h2>
                        <div className="col-12 col-xl-4 pt-2 ">
                        <div className={`${styles.facultyborder1}  h-100`}>
                            <div className="row pt-3 pb-3">
                                <div className="col-6 col-xl-6 offset-xl-2">
                                    <span >Date of Mock Test:</span><br />
                                    <span className={`${styles.dayValue}`}>21<sup>st</sup></span><br />
                                    <span>Sep 2025</span>
                                </div>
                                <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                                    <Image src="/images/icon/Calender-01.png" alt="clendar" width={50} height={50} />
                                </div>
                            </div>
                        </div>
                    </div>

                        <div className="col-12 col-xl-4 pt-2">
                        <div className={`${styles.facultyborder1} h-100`}>
                            <div className="row pt-3 pb-3">

                            <div className="col-6 col-xl-6 offset-xl-2">
                                
                                <span>Timings:</span><br />
                                <span className={`${styles.dayValue}`}>09:30 am </span><br />
                                <span>12:30 pm</span>
                            
                            </div>
                            <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                            <Image src="/images/icon/clock-01.png" alt="clendar" width={50} height={50} />
                            </div>
                            </div>
                        </div> 
                        </div>

                        <div className="col-12 col-xl-4 pt-2 ">
                        <div className={`${styles.facultyborder1}  h-100`}>
                            <div className="row pt-3 pb-3">
                                <div className="col-6 col-xl-6 offset-xl-2">
                                    <span >Closing Date:</span><br />
                                    <span className={`${styles.dayValue}`}>15<sup>th</sup></span><br />
                                    <span>Sep 2025</span>
                                </div>
                                <div className="col-6 col-xl-4 pt-3 pt-xl-0">
                                    <Image src="/images/icon/Calender-01.png" alt="clendar" width={50} height={50} />
                                </div>
                            </div>
                        </div>
                    </div>
                    

                    </div>
                    <div className="container">
                        <div className="row">
                        <div className="col-12 col-xl-6 pt-3">
                            <ul className={`${styles.ulclass} ps-1 pt-2`}>
                                {prelimlist.map((item,index)=>(
                                <li
                                  className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                  id={styles.acheiverrankspecial} key={index}
                                >
                                <div className="d-inline">
                                  <p className={`${styles.ullispan} d-inline`}>
                                    {item.list}
                                  </p>       
                                </div>
                                </li>
                                ))}
                            </ul>
                            <p className=""> <Image src={callbtn} alt="clendar" width={20} height={20} /> Call us for clarification - 9360816977</p>
                        </div>
                        </div>
                    </div>
                </div> 
            </section> */}
        

       {/* <section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
          <div className="container"> 
              <div className={`${styles.head}  pt-2 pb-2`}>
                <h3>TNPSC Group II/IIA Prelims State Level Mock Test - Venue</h3>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-4 col-12 mb-3">
                  <div className={`${styles.contactbox} h-100 `}>
                    <div className="row pt-3 pb-3">
                          <div className= {`${styles.addbox} px-4 pt-2`}>
                              <span>Shankar IAS Academy, Admission Office</span>
                              <p >Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040. <br/>Contact: 76677 66266</p>
                         </div>

                        
                    </div>
                 </div>
               </div>

               <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Shankar IAS Academy (Celestial Place)</span>
                                  <p>No. 255 , AL Block , 4th Avenue, Shanthi colony, Anna Nagar, Chennai - 600 040.<br/>Contact: 044-43533445 | 044-45543082</p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Chennai - ADYAR </span>
                                  <p >SHANKAR IAS ACADEMY , No-2/23, 3rd Cross Street, Padmanabhanagar, (Opposite to Sishya School), Adyar,  Chennai-600 020</p>
                              </div>
                          </div>
                    </div>
                </div>

                 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Cuddalore</span>
                                  <p >St. Antony's  Matriculation  Higher  secondary School , ECR Main  Road , Chinnakanganakuppam, <br/> Cuddalore - 607006</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Vellore</span>
                                  <p > Desia Matriculation  Higher Secondary School, Virupatchipuram, Vellore -632002 </p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Kancheepuram</span>
                                  <p >Thirumalai Engineering College, Krishnapuram Post , Kilambi, Kanchipuram - 631551</p>
                              </div>
                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Krishnagiri</span>
                                  <p>Nalanda Matriculation Hr. Sec School, Salem Bye Pass Road , Adjacent to Dairy Campus Krishnagiri -635001</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Erode</span>
                                  <p>V.V.C.R.Murugesanar Sengunthar  Girls Higher Secondary School, Thillai Nagar , Erode - 638001</p>
                              </div>
                          </div>
                    </div>
                </div>  

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Tirunelveli</span>
                                  <p>MDT Hindu School, Tirunelveli Junction, Tirunelveli</p>
                              </div>
                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                    <div className={`${styles.contactbox}`}>
                          <div className="row pt-3 pb-3">
                              <div className={`${styles.addbox} px-4 pt-2`} >
                                  <span>Thiruvarur</span>
                                  <p>Shankar IAS Academy, 3/310/7 GTN Complex, Mannai salai, (Opp to State Bank of India), Vilamal,<br/> Thiruvarur-610 001. <br/>
                                   Contact: 97877 34943 | 70102 62725 | 9787734943</p>
                              </div>
                          </div>
                    </div>
                </div>

               

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Madurai</span>
                                <p>Shankar IAS Academy, 5th Floor, Bata Show Room, GSP Plaza, Anna Nagar, Madurai-625020.<br/>
                                    Contact: 97896-22555</p>
                              </div>
                          </div>
                    </div>
                </div> 

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                              <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Salem</span>
                                <p>Shankar IAS Academy, NO.207/5, United Arcade, Kavery Avenue, State Bank Colony, Salem 636004.<br/>
                                  Contact: 0427-2441961 / 8940080039</p>
                              </div>

                          </div>
                       </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Trichy</span>
                                <p>Shankar IAS Academy, N.R.Towers, A9 (N),  Salai Road,  Thillai Nagar, Trichy-620018.
                                  Landmark: LIC -Rock Fort Branch Building <br/>
                                  Contact : 97896 64555 / 0431-4976911</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

                 <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>Namakkal</span>
                                <p>Shankar IAS Academy, Cheran Towers, Block No. 2/67, 1st floor West Thillaipuram Main Road, Paramathi Rd, Namakkal 637001</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4 col-12 mb-3">
                        <div className={`${styles.contactbox} h-100 `}>
                          <div className="row pt-3 pb-3">
                                <div className= {`${styles.addbox} px-4 pt-2`}>
                                <span>SHANKAR IAS ACADEMY, COIMBATORE.</span>
                                <p> 790, CROSS CUT ROAD, ZUDIO BUILDING, 3RD FLOOR, GANDHIPURAM, COIMBATORE. PIN - 641012. <br/>
                                  Contact:  0422-4380834 | 0422-4380835 | <br/> 94892 22761 | 87927 39577</p>
                                  
                              </div>

                          </div>
                    </div>
                </div>

              </div>
          </div>
        <br/>
        </section> */}

        <Footer />
    </>
  );
}




